import { render, staticRenderFns } from "./MoreStyleTitleEdit.vue?vue&type=template&id=65b12736"
import script from "./MoreStyleTitleEdit.vue?vue&type=script&lang=js"
export * from "./MoreStyleTitleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports